var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 10.833C17.598 10.833 15.6455 12.7855 15.6455 15.1872C15.6455 17.543 17.488 19.4497 19.8897 19.5322C19.963 19.523 20.0363 19.523 20.0913 19.5322C20.1097 19.5322 20.1188 19.5322 20.1372 19.5322C20.1463 19.5322 20.1463 19.5322 20.1555 19.5322C22.5022 19.4497 24.3447 17.543 24.3538 15.1872C24.3538 12.7855 22.4013 10.833 19.9997 10.833Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.6569 21.9799C22.0994 20.2749 17.9285 20.2749 15.3527 21.9799C14.1885 22.7499 13.5469 23.8041 13.5469 24.9316C13.5469 26.0591 14.1885 27.1041 15.3435 27.8741C16.6269 28.7358 18.3135 29.1666 20.0002 29.1666C21.6869 29.1666 23.3735 28.7358 24.6569 27.8741C25.8119 27.0949 26.4535 26.0499 26.4535 24.9133C26.4444 23.7949 25.8119 22.7408 24.6569 21.9799Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4226 26.6547C19.2759 26.6547 19.1292 26.5905 19.0192 26.4897L17.8642 25.3347C17.6442 25.1147 17.6442 24.748 17.8642 24.528C18.0842 24.308 18.4509 24.308 18.6709 24.528L19.4226 25.2797L21.3292 23.373C21.5492 23.153 21.9159 23.153 22.1359 23.373C22.3559 23.593 22.3559 23.9597 22.1359 24.1797L19.8259 26.4897C19.7159 26.5997 19.5692 26.6547 19.4226 26.6547Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.9c3364cb.svg";
export { ForwardRef as ReactComponent };